import React, { useContext } from "react";
import styled, { css } from "styled-components";

import { PlayerStateContext, UIStateContext } from "../../provider";
import SheetHead from "./sheet-head";
import Video from "./video-player";
import Overlay from "./video-overlay";
import Queue from "./queue";
import Controls from "./controls";
import Options from "./options";

import { Box, Row, Col, Img } from "../../comps";
import { IDs, Z_INDEX } from "../../constants";
import { PLAYER_CONTROLS, NAVBAR } from "../../theme/dimensions";
import { IS_ELECTRON_APP } from "../../config";

const PLAYER_MODE = {
  COLLAPSED: 0,
  EXPANDED: 1,
  MINI: 2,
  FULL: 3,
};

// width percentage of (100vw-navWidth)
const PLAYER_WIDTH = 62;
const QUEUE_WIDTH = 32;

const ControlsWrapper = styled(Box)`
  position: fixed;
  width: 100vw;
  height: ${PLAYER_CONTROLS.HEIGHT}px;
  bottom: 0px;
  right: 0px;
  z-index: ${Z_INDEX.playerControls};
`;

const SheetWrapper = styled(Box)`
  position: fixed;
  height: 0px;
  width: calc(100vw - ${NAVBAR.SIDE_WIDTH}px);
  bottom: ${PLAYER_CONTROLS.HEIGHT}px;
  right: 0px;
  z-index: ${({ mini }) => (mini ? Z_INDEX.miniWindow : Z_INDEX.playerSheet)};
  overflow: hidden;
  transition: height 500ms ease;
  background-color: ${({ theme }) => theme.color.BLACK_4};
  @media ${({ theme }) => theme.screenSize.miniWindow} {
    z-index: ${Z_INDEX.miniWindow};
  }
`;

const SheetContentWrap = styled(Col)`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100%;
  height: 100%;
  overflow: hidden;
  justify-content: space-around;
`;

const SheetBkg = styled(Img)`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  -webkit-filter: blur(50px);
  -moz-filter: blur(50px);
  -o-filter: blur(50px);
  -ms-filter: blur(50px);
  filter: blur(40px);
  opacity: 0.5;
`;

const SheetHeadWrapper = styled(Box)`
  width: 100%;
  height: 50px;
`;

const SheetContent = styled(Row)`
  width: 100%;
  height: calc(100% - 100px);
  justify-content: space-around;
  overflow: hidden;
`;

const LeftSide = styled(Col)`
  width: calc((${PLAYER_WIDTH} * (100vw - ${NAVBAR.SIDE_WIDTH}px)) / 100);
`;

const PlayerWrapper = styled(Box)`
  position: relative;
  width: 100%;
  height: calc(
    (9 * ((${PLAYER_WIDTH} * (100vw - ${NAVBAR.SIDE_WIDTH}px)) / 100)) / 16
  );
  ${({ mini }) =>
    mini &&
    (IS_ELECTRON_APP
      ? css`
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          z-index: ${Z_INDEX.miniWindow};
        `
      : css`
          position: fixed;
          right: 30px;
          bottom: ${PLAYER_CONTROLS.HEIGHT + 10}px;
          width: ${320}px;
          height: ${180}px;
          box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.6);
          z-index: ${Z_INDEX.miniWindow};
        `)}
`;

const VideoWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const OverlayWrapper = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const QueueWrapper = styled(Box)`
  width: calc((${QUEUE_WIDTH} * (100vw)) / 100);
  height: 100%;
`;

const OptionsWrapper = styled(Box)`
  width: 100%;
  height: 50px;
  margin-top: 20px;
`;

export default () => {
  const [playerState] = useContext(PlayerStateContext);
  const [UIState, setUIState] = useContext(UIStateContext);
  const { thumbnail } = playerState;
  const { playerMode } = UIState;

  const isDynamic = UIState.playerTheme === "dynamic";

  return (
    <div>
      <SheetWrapper
        id={IDs.PLAYER_SHEET}
        mini={playerMode === PLAYER_MODE.MINI}
      >
        {isDynamic && <SheetBkg src={thumbnail} />}
        <SheetContentWrap>
          <SheetHeadWrapper>
            <SheetHead />
          </SheetHeadWrapper>
          <SheetContent>
            <LeftSide>
              <PlayerWrapper
                id={IDs.VIDEO_PLAYER}
                mini={playerMode === PLAYER_MODE.MINI}
              >
                <VideoWrapper>
                  <Video />
                </VideoWrapper>
                <OverlayWrapper>
                  <Overlay />
                </OverlayWrapper>
              </PlayerWrapper>
              <OptionsWrapper>
                <Options />
              </OptionsWrapper>
            </LeftSide>
            <QueueWrapper>
              <Queue />
            </QueueWrapper>
          </SheetContent>
        </SheetContentWrap>
      </SheetWrapper>
      <ControlsWrapper>
        <Controls />
      </ControlsWrapper>
    </div>
  );
};
